module.exports = __webpack_public_path__ + "img/Logo.7b2127f8.svg";